export default class UpdateFileUploadStatus {
  constructor(
    totalNumber = 0
    , uploadedNumber = 0
  ) {
    this.totalNumber = totalNumber
    this.uploadedNumber = uploadedNumber
  }
}
